module.exports = __webpack_public_path__ + "static/cstoreslider-01-min-850c77cceb9e4d86cb1717b63e3f909a.jpg";